import { IconButton, Tooltip } from '@mui/material';
import { ChartPie as ChartPieIcon } from '@phosphor-icons/react/dist/ssr/ChartPie';
import { GearSix as GearSixIcon } from '@phosphor-icons/react/dist/ssr/GearSix';
import { PlugsConnected as PlugsConnectedIcon } from '@phosphor-icons/react/dist/ssr/PlugsConnected';
import { User as UserIcon } from '@phosphor-icons/react/dist/ssr/User';
import { Users as UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { XSquare } from '@phosphor-icons/react/dist/ssr/XSquare';

// The navIcons object maps the icon name (string) to the actual Phosphor icon component.
export const navIcons = {

};

// NavIcons component that renders a button for each icon.
const NavIcons = () => {
  return (
    <div>
      {Object.keys(navIcons).map((iconName) => {
        const IconComponent = navIcons[iconName];
        return (
          <Tooltip key={iconName} title={iconName}>
            <IconButton>
              <IconComponent />
            </IconButton>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default NavIcons; // Default export for the NavIcons component
